import React, { useState } from "react";
import scannedMediaObjectListStyle from "./scannedMediaObjectListStyle";
import LegalbirdLoader from "../ContentLoader/LegalbirdLoader";
import { Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import ContentBox from "../ContentBox/ContentBox";
import _ from "lodash";
import ScannedMediaObjectRow from "./ScannedMediaObjectRow";
import ButtonLoading from "../Button/ButtonLoading";
import ActionIdentifierProvider from "../../provider/ActionIdentifierProvider";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { fetchCollection, queryKeys } from "../../services/ReactQuery/reactQueryService";
import { apiPost } from "../../services/Api/apiCall";
import DocumentClassLabelAiProvider from "../../provider/DocumentClassLabelAiProvider";

export default function ScannedMediaObjectList({}) {
  const [isLoading, setIsLoading] = useState(false);
  const queryClient = useQueryClient();

  let mediaObjectsFilter = {
    scanCheck: "required",
  };
  const { data: mediaObjectsCollection } = useQuery({
    queryKey: queryKeys.collection("media_objects", mediaObjectsFilter),

    queryFn: () =>
      fetchCollection("media_objects", mediaObjectsFilter)
  });

  const mediaObjects = mediaObjectsCollection ? mediaObjectsCollection["hydra:member"] : [];

  if (!mediaObjectsCollection) {
    return <LegalbirdLoader centered />;
  }

  const handleConfirmClick = async () => {
    setIsLoading(true);
    let checkedMediaObjects: number[] = [];
    _.forEach(mediaObjects, (mediaObject) => {
      if (mediaObject.scanMetaData?.checkedDate) {
        checkedMediaObjects.push(mediaObject.id);
      }
    });
    await apiPost("lb/services/checked_media_objects", checkedMediaObjects);
    await queryClient.invalidateQueries({
      queryKey: queryKeys.collection("media_objects", mediaObjectsFilter)
    });
    setIsLoading(false);
  };

  return (
    <ContentBox>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Datum</TableCell>
            <TableCell>Datei</TableCell>
            <TableCell>Fall</TableCell>
            <TableCell sx={scannedMediaObjectListStyle.searchColumn} width={"25%"}>
              Suche
            </TableCell>
            <TableCell sx={scannedMediaObjectListStyle.identifierColumn}>Dokumentenart</TableCell>
            <TableCell sx={scannedMediaObjectListStyle.identifierColumn}>Aktion</TableCell>
            <TableCell>Prüfen</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <DocumentClassLabelAiProvider>
            <ActionIdentifierProvider>
              {mediaObjects.length < 1 ? (
                <TableRow>
                  <TableCell colSpan={7} sx={scannedMediaObjectListStyle.centerText}>
                    Keine zuzuordnenden Dateien
                  </TableCell>
                </TableRow>
              ) : (
                _.map(mediaObjects, (mediaObject) => (
                  <ScannedMediaObjectRow
                    mediaObject={mediaObject}
                    key={mediaObject.id}
                    refreshList={() =>
                      queryClient.invalidateQueries({
                        queryKey: queryKeys.collection("media_objects", mediaObjectsFilter)
                      })
                    }
                  />
                ))
              )}
            </ActionIdentifierProvider>
          </DocumentClassLabelAiProvider>
        </TableBody>
      </Table>
      <ButtonLoading
        variant={"contained"}
        sx={scannedMediaObjectListStyle.button}
        onClick={handleConfirmClick}
        isLoading={isLoading}
        disabled={!_.find(mediaObjects, (mediaObject) => mediaObject.scanMetaData?.checkedDate)}
      >
        Prüfung bestätigen
      </ButtonLoading>
    </ContentBox>
  );
}
